import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";

export const useMeta = (id, enabled = true) => {

    // const statusMsg = "failed"

    return useQuery({
        queryKey: [`oper_meta_ror_${id}`],
        queryFn: async () => getData(`/${MAIN_REJESTR_API_SHORT}/meta/${id}`),
        enabled: enabled,
        refetchOnMount: 'always',

    })

}